import { render, staticRenderFns } from "./NbDropFile.vue?vue&type=template&id=3f154828&scoped=true&"
import script from "./NbDropFile.vue?vue&type=script&lang=js&"
export * from "./NbDropFile.vue?vue&type=script&lang=js&"
import style0 from "./NbDropFile.vue?vue&type=style&index=0&id=3f154828&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f154828",
  null
  
)

export default component.exports